import { MenuItem } from '@headlessui/react';
import { Link, type LinkProps } from '@tanstack/react-router';
import cn from 'classnames';

type TAnchor = JSX.IntrinsicElements['a'];
type TButton = JSX.IntrinsicElements['button'];
type TLink = TAnchor & LinkProps;

export type ListItem = (Omit<TButton, 'ref'> | TLink) & {
  as?: React.ElementType;
  iconEnd?: React.ReactNode;
  iconStart?: React.ReactNode;
  variant?: 'default' | 'red';
};

export function ListItem({
  as = 'button',
  children,
  className,
  disabled,
  iconEnd,
  iconStart,
  variant = 'default',
  ...props
}: ListItem) {
  const Tag = 'to' in props ? Link : as;

  return (
    <MenuItem>
      <Tag
        className={cn(
          'flex h-8 w-full items-center gap-x-2 rounded-[6px] bg-transparent px-2 py-1.5 text-14/100% font-medium transition-colors duration-100 [&>svg]:h-[18px] [&>svg]:w-[18px]',
          {
            'enabled:hover:bg-gray-200 data-[active]:bg-gray-200': !disabled,
            'opacity-40': disabled,
            'text-gray-700 hover:text-gray-700': variant === 'default',
            'text-red-700 hover:text-red-700': variant === 'red',
          },
          className,
        )}
        {...(as !== 'div'
          ? {
              disabled,
            }
          : {})}
        {...(as === 'button'
          ? {
              type: 'button',
            }
          : {})}
        {...props}
      >
        {iconStart}
        <span className="flex-1 text-left">{children}</span>
        {iconEnd}
      </Tag>
    </MenuItem>
  );
}
